"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricUnitTypeEnum = void 0;
var MetricUnitTypeEnum;
(function (MetricUnitTypeEnum) {
    MetricUnitTypeEnum["Number"] = "NUMBER";
    MetricUnitTypeEnum["Decimal"] = "DECIMAL";
    MetricUnitTypeEnum["String"] = "STRING";
    MetricUnitTypeEnum["Percent"] = "PERCENT";
    MetricUnitTypeEnum["Second"] = "SECOND";
    MetricUnitTypeEnum["Count"] = "COUNT";
    MetricUnitTypeEnum["Date"] = "DATE";
    MetricUnitTypeEnum["DateTime"] = "DATETIME";
    MetricUnitTypeEnum["Week"] = "WEEK";
    MetricUnitTypeEnum["Month"] = "MONTH";
    MetricUnitTypeEnum["Countdown"] = "COUNTDOWN";
    MetricUnitTypeEnum["Boolean"] = "BOOLEAN";
    MetricUnitTypeEnum["Status"] = "STATUS";
    MetricUnitTypeEnum["HOUR_OF_DAY"] = "HOUR_OF_DAY";
    MetricUnitTypeEnum["WEEKDAY"] = "WEEKDAY";
    MetricUnitTypeEnum["TimelineEvent"] = "TIMELINE_EVENT";
})(MetricUnitTypeEnum = exports.MetricUnitTypeEnum || (exports.MetricUnitTypeEnum = {}));
